import { Breadcrumb, Layout, Space, Menu } from "antd";
import { Content, Header } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import SubMenu from "antd/lib/menu/SubMenu";
import Footer from "rc-table/lib/Footer";
import 'antd/dist/antd.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams
} from "react-router-dom";
import FixturesDesktop from "./Pages/FixturesDesktop";
import FixturesMobile from "./Pages/FixturesMobile";
import PointsTable from "./Pages/PointsTable";
import Venues from "./Pages/Venues";
import FixturesVerticle from "./Pages/FixturesVerticle";
import FixturesDesk from "./Pages/FixturesDesk";
import MatchDetails from "./Pages/MatchDetails";


export default function App() {
  return (
    <Router>
      <Layout className="layout">
        {/* <Header>
            <div className="logo" />
            <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['2']}>
              <Menu.Item key={0}><Link to="/fixvert/23">Fixtures</Link></Menu.Item>
              <Menu.Item key={3}><Link to="/match/714">Match Details</Link></Menu.Item>
            </Menu>
          </Header> */}
        <Content style={{ padding: '0 0px' }}>
          {/* <Breadcrumb style={{ margin: '16px 0' }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>List</Breadcrumb.Item>
            <Breadcrumb.Item>App</Breadcrumb.Item>
          </Breadcrumb> */}
          <div className="site-layout-content">
            <Switch>
              <Route path="/about">
                <About />
              </Route>
              <Route path="/users">
                <Users />
              </Route>
              <Route path="/FixturesDesktop">
                <FixturesDesktop />
              </Route>
              <Route path="/FixturesDesk/:id">
                <FixturesDesk />
              </Route>
              <Route path="/FixturesMobile/:id">
                <FixturesMobile />
              </Route>
              <Route path="/pointstable">
                <PointsTable />
              </Route>
              <Route path="/venues">
                <Venues />
              </Route>
              <Route path="/fixvert/:id">
                <FixturesVerticle />
              </Route>
              <Route path="/match/:id">
                <MatchDetails />
              </Route>
              <Route path="/">
                <Home />
              </Route>
            </Switch>
          </div>
        </Content>
        {/* <Layout.Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Layout.Footer> */}
      </Layout>

      <div>
        

        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
       
      </div>
    </Router>
  );
}

function Home() {
  return <h2>Home</h2>;
}

function About() {
  return <h2>About</h2>;
  
}

function Users() {
  let match = useRouteMatch();
  
  return (
    <div>
      <h2>Topics</h2>

      <ul>
        <li>
          <Link to={`${match.url}/components`}>Components</Link>
        </li>
        <li>
          <Link to={`${match.url}/props-v-state`}>
            Props v. State
          </Link>
        </li>
      </ul>

      <Switch>
        <Route path={`${match.path}/:topicId`}>
          <Topic />
        </Route>
        <Route path={match.path}>
          <h3>Please select a topic.</h3>
        </Route>
      </Switch>
    </div>
  );
}

function Topic() {
  let { topicId } = useParams();
  return <h3>Requested topic ID: {topicId}</h3>;
}